export const OFFLINE_PAID_POST_MIGRATION_ID = 'offlinePaidPostMigration';

export type MigrationId = typeof OFFLINE_PAID_POST_MIGRATION_ID;
